__turbopack_context__.v({
  "large": "ButtonOutlined-module__H-agRa__large",
  "medium": "ButtonOutlined-module__H-agRa__medium",
  "root": "ButtonOutlined-module__H-agRa__root",
  "small": "ButtonOutlined-module__H-agRa__small",
});
